import React, { Component } from "react";
import BannerAnim from "rc-banner-anim";
import QueueAnim from "rc-queue-anim";
import TweenOne from "rc-tween-one";
import { Grid, Button } from "react-bootstrap";
import data from "../config.banner";

import "./Banner.css";
import "./Banner-base.css";

const { Element } = BannerAnim;
const BgElement = Element.BgElement;

const VideoPlayer = () => (
  <video className="banner-video" height="auto" controls>
    <source src="/video.mp4" type="video/mp4" />
    Tu navegador no soporta la reproducción de videos.
  </video>
);

export default class Banner extends Component {
  constructor(props) {
    super(props);
    this.state = {
      children: [
        this.renderBanner(
          "1",
          data.banners[0].img,
          data.banners[0].title,
          data.banners[0].description
        ),
        this.renderBanner(
          "2",
          data.banners[1].img,
          data.banners[1].title,
          data.banners[1].description
        ),
      ],
    };
  }

  componentDidMount() {
    const children = this.state.children;

    setTimeout(() => {
      for (var i = 2; i < data.banners.length; i++) {
        children.push(
          this.renderBanner(
            i + 1,
            data.banners[i].img,
            data.banners[i].title,
            data.banners[i].description
          )
        );
      }
      this.setState({
        children,
      });
    }, 2000);
  }

  renderBanner(key, img, title, first_text) {
    return (
      <Element key={key} prefixCls="banner-user-elem">
        <BgElement
          key="bg"
          className="bg"
          style={{
            backgroundImage: "url(" + img + ")",
            backgroundSize: "cover",
            backgroundPosition: "35%",
          }}
        />

        <TweenOne
          animation={{ y: 50, opacity: 0, type: "from", delay: 200 }}
          name="TweenOne2"
          className="TweenOne2"
        >
          {
            title ?
            <Grid className="banner-content">
              <h1 key="h1">{title}</h1>
              <p key="p">{first_text}</p>
              {this.props.onContact && (
                <Button onClick={this.props.onContact} bsStyle="info">
                  Cont&aacute;ctanos
                </Button>
              )}
            </Grid>
            :
            <Grid className="banner-content">
              <h1>Expertos en mitigaciones y permisolog&iacute;a</h1>
              <VideoPlayer />
            </Grid>
          }
        </TweenOne>
      </Element>
    );
  }

  render() {
    return (
      <BannerAnim
        type="grid"
        autoPlay={false}
        autoPlaySpeed={5000}
        autoPlayEffect={false}
      >
        {this.state.children}
      </BannerAnim>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Banner.js